export const ArchiveConfirmConsts = {
  TITLE: "Archive",
  MODAL_WITH: "40rem",
  MESSAGE: "Are you sure you want to archive this job?",
  REASON_LABEL: "Reason",
  REASON_PLACEHOLDER: "Enter Reason",
  REASON_NAME: "archiveReason",
  ARCHIVE_SUCCESS: "Job archived succesfully",
};
